export default __webpack_public_path__ + "static/media/heroB.4930fd71.jpg";